<template>
  <div
    class="d-inline ml-1"
    v-if="Number(previousNumber) !== 0 && isFinite(previousNumber)"
  >
    <font-awesome-icon
      class="small fa-sm"
      :class="
        (!opposite && previousNumber > 0) || (opposite && previousNumber < 0)
          ? 'text-success'
          : (!opposite && previousNumber < 0) ||
            (opposite && previousNumber > 0)
          ? 'text-danger'
          : 'd-none'
      "
      :icon="
        previousNumber > 0
          ? 'arrow-up'
          : previousNumber < 0
          ? 'arrow-down'
          : 'arrow-up'
      "
    />
    <span class="font-weight-thin fs-14"

    :class="
        (!opposite && previousNumber > 0) || (opposite && previousNumber < 0)
          ? 'text-success'
          : (!opposite && previousNumber < 0) ||
            (opposite && previousNumber > 0)
          ? 'text-danger'
          : 'text-muted'
      "    
      >{{ abs(previousNumber) }}%</span
    >
  </div>
</template>

<script>
export default {
  props: ['previousNumber', 'opposite'],
  data: function () {
    return {}
  },
  methods: {
    abs(n) {
      return Math.abs(n)
    },
  },
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/CompareStat.vue